import React, { useState, useEffect, Component } from "react";
import styled from "styled-components";

const STPLPlans = (props) => {
  const { planData } = props;

  const buttonStyleEnabled = { background: "#003E8D", pointerEvents: "auto" };
  const buttonStyleDisabled = { background: "#a8aad3", pointerEvents: "none" };
  const [buttonStyle, setButtonStyle] = useState(buttonStyleEnabled);

  /* disable buttons and input field once user is logout (css style)*/
  // useEffect(()=>{
  //   //  console.log(props.logoutUser);
  //     if(props.logoutUser == false || props.logoutUser == undefined){
  //        disableButtons(true);
  //     }else{
  //         disableButtons(false);
  //     }
  // },[props.logoutUser]);
  // const  disableButtons = (isDisabled) => {
  //     if(isDisabled){ setButtonStyle(buttonStyleDisabled); }
  //     else{ setButtonStyle(buttonStyleEnabled) }
  // }

  const handleSelectOnclick = (sendData) => {
    if (sendData.maximumAmount == "79999") {
      let inputString =
        "XXXXX for XX months" + "<split>" + JSON.stringify(sendData);
      window["autosubmit"](inputString);
    } else {
      let inputString =
        sendData.maximumAmount +
        " for " +
        sendData.tenure +
        " months " +
        "<split>" +
        JSON.stringify(sendData);
      window["autosubmit"](inputString);
      // console.log(JSON.stringify(sendData));
    }
    document.getElementById("showPlanData").style.pointerEvents = "none";
    setButtonStyle(buttonStyleDisabled);
    //console.log(sendData);
  };
  //css
  const SelectButton = styled.div`
    width: 95%;
    border: 1px solid ${buttonStyle.background};
    border-radius: 4px;
    color: ${buttonStyle.background};
    text-align: center;
    line-height: 2;
    margin: 10px auto;
    padding: 0px 5px;
    pointer-events: ${buttonStyle.pointerEvents};
    :hover {
      color: #fff;
      cursor: pointer;
      background: #003e8d;
    }
  `;
  //
  const showPlanData = () => {
    return (
      <div id="showPlanData">
        {planData.map((e, i) => {
          return (
            <div  className="action-elem" onClick={() => handleSelectOnclick(e)} key={i}>
              &#8377; {e.maximumAmount} for {e.tenure} months
            </div>
          );
        })}
      </div>
    );
  };
  return <React.Fragment>{showPlanData()}</React.Fragment>;
};

//******* XpressCashPlansForSpecicAmt *********************************************************

const STPLPlansForSpecicAmt = (props) => {
  const { planData } = props;

  const buttonStyleEnabled = { background: "#003E8D", pointerEvents: "auto" };
  const buttonStyleDisabled = { background: "#a8aad3", pointerEvents: "none" };
  const [buttonStyle, setButtonStyle] = useState(buttonStyleEnabled);

  let sendData = [];

  /* disable buttons and input field once user is logout (css style)*/
  // useEffect(()=>{
  //   //  console.log(props.logoutUser);
  //     if(props.logoutUser == false || props.logoutUser == undefined){
  //        disableButtons(true);
  //     }else{
  //         disableButtons(false);
  //     }
  // },[props.logoutUser]);
  // const  disableButtons = (isDisabled) => {
  //     if(isDisabled){ setButtonStyle(buttonStyleDisabled); }
  //     else{ setButtonStyle(buttonStyleEnabled) }
  // }

  const handleProceed = () => {
    if (sendData.length != 0) {
      let inputString =
        sendData.tenureInMonths +
        " Months" +
        "<split>" +
        JSON.stringify(sendData);
      window["autosubmit"](inputString);

      document.getElementById("showPlanData").style.pointerEvents = "none";
      setButtonStyle(buttonStyleDisabled);
    } else {
      props.overlayMessageToggle("Please select EMI options");
    }
    //   console.log(sendData);
  };

  const handleRadioChange = (selectedEMIPlan) => {
    //console.log("radio clicked!!!");
    //console.log( selectedEMIPlan);

    sendData = selectedEMIPlan;

    //console.log(sendData);
  };
  //css
  const ButtonProceed = styled.div`
    width: 95%;
    // background: #003E8D;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
    margin: 10px auto;
    pointer-events: ${buttonStyle.pointerEvents};
    background: ${buttonStyle.background};
  `;
  const MainBlock = styled.div`

        // background: pink;
        height:auto;
        margin:20px 0;

        & .amount-block{
            // background: yellow;
            padding:10px;
        }
        & .amount-label{
           padding-left: 4px;
           color: #000
       
        }
        & .amount-input{
            background-color: #fff;
            border: 0px solid;
            box-shadow: 0px 5px 12px rgba(0,0,0,0.2);
            border-radius: 2px;
            height: 40px;
            width: 100%;
            color: #CCC;
        }
        & .tenure-block{
            padding: 0px 10px;
           
        }
        & .tenure-label{
            padding-left: 4px;
            color: #000

        }
        & .EMI_tenure{
            padding-top:10px;
            background: #fff;
            border: 0px solid;
            box-shadow: 0px 5px 12px rgba(0,0,0,0.2);
            border-radius: 4px;
           
        }

        & .radioSelect{
            font-size:14px;
            padding:10px;
            border: 1px solid rgba(0,0,0,0.1);
            border-radius: 6px;
            margin-left:8px;
            margin-bottom: 8px;
            width:45.5%;
            display: inline-block;
            color: #003E8D;
            font-weight:500;
            background: none;
        }
    `;
  //
  const showPlanData = (val) => {
    return (
      <div id="showPlanData">
        {/* <div>Awesome! Please enter the amount you want to avail and select the tenure of your loan.</div> */}
        <MainBlock>
          {/* <div className="amount-block">
                        <label className= "amount-label">Amount</label><br></br>
                        <input className= "amount-input" placeholder="   Enter the Amount"></input>
                </div> */}

          <div className="tenure-block">
            {/* <label className="tenure-label">Tenure</label> */}

            <div className="EMI_tenure">
              {planData.map((item, i) => {
                return (
                  <div
                    className="radioSelect disable-item"
                    key={i}
                    onChange={() => handleRadioChange(item)}
                  >
                    <input
                      type="radio"
                      style={{ cursor: "pointer" }}
                      name={item.planID}
                    />
                    <label style={{ marginLeft: "1px" }}>
                      {item.tenureInMonths} Months
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "300",
                          color: "#666666",
                        }}
                      >
                        Processing Fee: ₹{item.processingFee_Amount}
                      </div>
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
        </MainBlock>
      </div>
    );
  };
  return (
    <React.Fragment>
      {showPlanData()}
      <div className="action-elem" onClick={() => handleProceed()}>Submit</div>
    </React.Fragment>
  );
};

export { STPLPlansForSpecicAmt };

export default STPLPlans;
